import React, { Suspense } from 'react'
import { Activity, Settings } from 'react-feather'
import { BsFolderPlus } from 'react-icons/bs'
import { Redirect, Route, RouteProps, Switch } from 'react-router'
import { BrowserRouter as Router } from 'react-router-dom'
import { FillLoader } from '../components'
import SideBar from '../components/SideBar'
import PageNotFound from '../containers/PageNotFound'
import { useAuthContext } from '../context/AuthProvider'
import { useSocketConnector } from '../hooks'
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from './routes'

interface RouteType extends RouteProps {
  component: any
}

export type NavItem = {
  to: string
  title: string
  icon: React.ReactNode
  subMenu?: Array<{ to: string; title: string }>
}

const NAV_ITEMS: NavItem[] = [
  {
    to: `/auth/my-activities`,
    title: 'My Activities',
    icon: <Activity size={18} color="white" className="sidebar-menu-icon" />
  },
  {
    to: `/auth/report-tasks`,
    title: 'Report tasks',
    icon: <BsFolderPlus size={18} className="sidebar-menu-icon" />
  },
  {
    to: `/auth/settings`,
    title: 'Settings',
    icon: <Settings size={18} style={{ transform: 'scaleX(-1)' }} className="sidebar-menu-icon" />
  }
]

const PrivateRoute = ({ component: Component, ...rest }: RouteType) => {
  const { isAuthenticating, isAuthenticated } = useAuthContext()
  useSocketConnector()

  if (isAuthenticating) {
    return <FillLoader />
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Suspense fallback={<FillLoader color="black" />}>
            <Component {...rest} />
          </Suspense>
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  )
}

const PublicRoute = ({ component: Component, ...rest }: RouteType) => (
  <Route {...rest}>
    <Component />
  </Route>
)

const Navigation = () => (
  <Router>
    <Suspense fallback={<FillLoader />}>
      <Switch>
        {PUBLIC_ROUTES.map((route) => {
          return <PublicRoute key={route.path} {...route} />
        })}

        {/* Private routes without the admin wrapper */}
        {PRIVATE_ROUTES.filter((route) => route.hidePageWrap).map((route) => {
          return <PrivateRoute key={route.path} {...route} />
        })}

        {/* Normal auth routes with admin wrapper */}
        <Route
          path="/auth"
          render={() => {
            return (
              <SideBar
                bg="white"
                color="text.50"
                navItems={NAV_ITEMS}
                hoverColor="green.50"
                accentColor="green.500"
              >
                {PRIVATE_ROUTES.filter((route) => !route.hidePageWrap).map((route) => (
                  <PrivateRoute key={route.path} {...route} />
                ))}
              </SideBar>
            )
          }}
        />
        <Route path="/terms-and-conditions.pdf" />
        <Route render={PageNotFound} />
      </Switch>
    </Suspense>
  </Router>
)

export default Navigation
